<template>
  <footer>
    <div class="footer-inner">

      <div class="logo"><router-link :to="'/'"><img src="../assets/logogrey.svg"></router-link></div>

      <nav class="footer-menu">
        <li class="desktop"><router-link :to="'/browse'">Locations</router-link></li>
        <li><router-link :to="'/contact'">Contact</router-link></li>
        <li><router-link :to="'/submitproperty'">List Your Property</router-link></li>
        <li><router-link :to="'/about'">About</router-link></li>
      </nav>

      <div class="contact">
        <a href="tel:3238740404" class="phone">(323) 874-0404</a>
        <a href="mailto: office@productionlocations.com" class="email">office@productionlocations.com</a>
      </div>

      <div class="segments">

        <div class="corporateaddress">
          <h4>Corporate Mailing Address</h4>
          <p>9663 Santa Monica Blvd. #490<br>
              Beverly Hills, CA 90210</p>
        </div>

        <div class="officeaddress">
          <h4>Downtown Office</h4>
          <p>756 S Broadway #1110<br>Los Angeles, CA 90014</p>
        </div>

<!--
        <div class="emailsignup">
          <h4>Get Updates</h4>
          <p><input type="text" name="email" placeholder="Enter your email"></p>
        </div>
-->

        <div class="social">
          <h4>Connect</h4>
          <p>
            <a class="facebook" href="https://www.facebook.com/ProductionLocations"><img src="../assets/facebook.svg" /></a>
            <a class="twitter" href="https://twitter.com/PLocations"><img src="../assets/twitter.svg" /></a>
            <a class="instagram" href="https://www.instagram.com/productionlocations/"><img src="../assets/instagram.svg" /></a>
            <a class="linkedin" href="https://www.linkedin.com/company/production-locations?trk=ppro_cprof"><img src="../assets/linkedin.svg" /></a>
          </p>
        </div>

        <div></div>

      </div>

      <div class="copyright">
        All content &copy; {{ (new Date()).getFullYear() }} Production Locations
      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'MainFooter'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";
  footer {
    background: $notblack;
    padding: 28px 0 12px;
    text-align: center;
    color: #FFF;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
  }

  .logo {
    img {
      height: 30px;
      @include bp(most) {
        height: 50px;
      }
    }
  }

  nav {
    margin-top: 13px;
    li {
      display: inline-block;
      margin: 0 .5em;
      @include bp(most) {
        margin: 0 1.5em;
      }
      a {
        color: #FFF;
        font-weight: 600;
        text-transform: uppercase;
        text-decoration: none;
        font-size: 10px;
        &:hover {
          color: $yellow;
        }
        @include bp(most) {
          font-size: 1em;
        }
      }
      &.desktop {
        display: none;
        @include bp(most) {
          display: inline-block;
        }
      }
    }
  }

  .contact {
    margin-top: 25px;
    a {
      color: #FFF;
      display: block;
      text-decoration: none;
      font-weight: 300;
    }
    .phone {
      font-size: 18px;
      font-weight: 800;
      line-height: 2;
    }
  }

  .segments {
      text-align: justify;
      max-width: 90%;
      margin: 30px auto 12px;
      @include bp(most) {
        max-width: 700px;
        margin: 30px auto 26px;
      }
      & > div {
        display: inline-block;
        text-align: center;
        vertical-align: top;
        &:last-child {
          height: 1px; width: 100%;
        }
        &.corporateaddress, .officeaddress {
          display: none;
          @include bp(most) {
            display: inline-block;
          }
        }
      }
      h4 {
       color: $darkgrey;
       margin: 0 0 1em;
       font-weight: 600;
      }
      p {
        margin: 0;
      }
      input {
       background: none;
       box-shadow: none;
       outline: none;
       border: 0px none;
       border-bottom: 1px solid $darkgrey;
       font-family: $montserrat;
       font-size: 12px;
       text-align: center;
       min-width: 144px;
       line-height: 20px;
       color: #FFF;
      }
      .social {
        padding-right: 1em;
        @include bp(most) {
          padding-right: 4em;
        }
        a {
          color: #FFF;
          text-decoration: none;
          padding: 0 5px;
        }
      }
  }

  .copyright {
    color: $darkgrey;
    font-family: $noto;
    font-size: 10px;
  }

</style>



// WEBPACK FOOTER //
// MainFooter.vue?5f725925